<!--
 * @Description:
 * @Author: gonghong
 * @Date: 2024-02-21 14:03:01
 * @LastEditTime: 2024-02-27 15:52:13
-->
<template>
    <div class="header">
        <!-- TODO 平台LOGO -->
        <div class="header-left-content">
            <!-- <img src="@/assets/image/header-logo.png" style="height: 100%" /> -->
            <!-- 主logo -->
            <img :src="baseConfigInfo.image" style="height: 26px" 
                v-if="baseConfigInfo.logoShow"
            >
            <div class="line" style="margin: 0 8px;"
                v-if="baseConfigInfo.logoShow 
                      && baseConfigInfo.smallLogoShow"
            />
            <!-- 副logo  smallLogo -->
            <img :src="baseConfigInfo.smallLogo" style="height: 26px" 
                v-if="baseConfigInfo.smallLogoShow"
            >
            <!-- 系统名称 -->
            <span class="txt" style="margin-left: 10px;"
                v-if="baseConfigInfo.systemNameShow"
            >{{ 
                baseConfigInfo.systemName 
            }}</span>
            <div class="line"  style="margin: 0 16px;"
                v-if="baseConfigInfo.logoShow 
                      || baseConfigInfo.smallLogoShow
                      || baseConfigInfo.systemNameShow"
            />
            <div class="txt">工作台</div>
        </div>
        <div class="header-right-content">
            <n-space :size="20">
                <!-- TODO 消息通知 -->
                <!-- <n-badge dot>
                    <n-icon size="26">
                        <BellOutlined style="cursor: pointer;"/>
                    </n-icon>
                </n-badge> -->
                <div style="height: 100%; display: flex; align-items: center">
                    <div style="display: flex">
                        <!-- <img
                            src="@/assets/image/daping.png"
                            alt=""
                            style="width: 32px; height: 18px; margin-right: 24px; cursor: pointer"
                            @click="goToLargeScreen"
                        /> -->
                        <img
                            src="@/assets/image/wenhao.png"
                            alt=""
                            style="width: 16px; height: 16px; margin-right: 24px; cursor: pointer"
                            @click="goToHelp"
                        />
                        <!-- <img src="@/assets/image/lingdang.png" alt="" style="width: 16px; height: 16px;"> -->
                        <n-badge :max="99" :value="totalInfo" @click="goToInfoDetail">
                            <img
                                src="@/assets/image/lingdang.png"
                                alt=""
                                style="width: 16px; height: 16px; cursor: pointer"
                            />
                        </n-badge>
                    </div>
                </div>
                <!-- TODO  切换全屏-->
                <!-- <n-tooltip placement="bottom">
                    <span>{{ isFull ? '退出全屏' : '全屏 ' }}</span>
                    <template #trigger>
                        <n-icon size="28">
                             <component
                                :is="isFull ? fullscreenIcon[0] : fullscreenIcon[1]"
                                @click="toggleFullScreen"
                                style="cursor: pointer; width: 20px; height: 20px;"
                            />
                        </n-icon>
                    </template>
                </n-tooltip> -->

                <!-- TODO 用户功能 -->
                <n-dropdown trigger="click" :options="avatarOptions" @select="avatarSelect">
                    <!-- <n-space :size="5" style="align-items: center;cursor: pointer;">
                        <n-avatar style="background-color: #1890ff" round size="small">
                            <n-icon>
                                <UserOutlined />
                            </n-icon>
                        </n-avatar>
                        <span style="color: #616A6E;font-size: 14px;font-weight: 400;">{{ username }}</span>
                    </n-space> -->
                    <div style="display: flex; align-items: center; height: 100%">
                        <div style="display: flex; align-items: center">
                            <!-- <img src="@/assets/image/touxiang.png" alt="" style="width: 24px; height: 24px; margin-right: 8px;"> -->
                            <n-avatar
                                round
                                :src="defaultAvatar"
                                style="height: 24px; width: 24px; margin-right: 8px"
                            ></n-avatar>
                            <span
                                style="
                                    color: #616a6e;
                                    font-size: 14px;
                                    font-weight: 400;
                                    margin-right: 24px;
                                    cursor: pointer;
                                "
                                >{{ username }}</span
                            >
                        </div>
                    </div>
                </n-dropdown>
            </n-space>
        </div>
    </div>
</template>

<script setup>
// import { FullscreenOutlined, FullscreenExitOutlined, BellOutlined, UserOutlined } from '@vicons/antd'
import { FullscreenOutlined, FullscreenExitOutlined } from '@vicons/antd'
import { ref, markRaw, reactive, computed, onMounted } from 'vue'
import Api from '@/api/system'
import ApiAxios from '@/axios'
import { useSystemStore } from '@/store/modules/system'
import { useDialog, useMessage, NAvatar } from 'naive-ui'
import { loginoutClear } from '@/utils/auth'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { basicConfigStore } from '@/store/modules/basicConfig'
// 初始化加载基础配置
onMounted(() => {
    getBaseConfigList()
})
// 获取基础配置信息
const getBaseConfigList = () => {
    Api.getBaseConfig.request().then((res) => {
        // if (res.code == 200 && res.data[0]?.image !== null) {
        if (res.code == 200 && res.data?.image !== null) {
            // setConfigInfo(res.data[0])
            setConfigInfo(res.data)
        }
    })
}
const configStore = basicConfigStore()
const { getconfigInfoMation } = storeToRefs(configStore)
const { setConfigInfo } = basicConfigStore()
const baseConfigInfo = computed(() => getconfigInfoMation.value)
const dialog = useDialog()
const message = useMessage()
const avatarOptions = reactive([
    {
        // label: '修改密码',
        // key: 'editPassword',
        label: '个人中心',
        key: 'editUserInfo',
    },
    {
        label: '退出登录',
        key: 'loginOut',
    },
])
// const username = ref('')
// 是否全屏显示
const isFull = ref(false)
const fullscreenIcon = markRaw([FullscreenExitOutlined, FullscreenOutlined])
const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
        // 全屏
        document.documentElement.requestFullscreen()
        isFull.value = true
    } else if (document.exitFullscreen) {
        // 退出全屏
        document.exitFullscreen()
        isFull.value = false
    }
}

const userId = ref('')
const roleList = ref([])
// 消息总数
// const totalInfo = ref(0)
// 并不能立马触发，会一直进行抛错
// Api.getUserInfo.request().then(result => {
//     const userInfo = result.data || {}
//     const { setUserInfo } = useSystemStore()
//     setUserInfo(userInfo)

//     username.value = userInfo.nickName
// })
const { setUserInfo, setUserAvatar } = useSystemStore()

const fetchData = async () => {
    try {
        const result = await Api.getUserInfo.request()
        // console.log("result", result);
        const userInfo = result.data || {}
        setUserInfo(userInfo)
        // setUserAvatar(userInfo)
        // console.log('userInfo===》', userInfo)
        roleList.value = userInfo?.roleList || []
        userId.value = userInfo.userId
        if (userInfo?.userId) {
            const url = '/user/avatar/' + userId.value
            // console.log("url", url);
            const getUserAvatarByUserId = ApiAxios.newGet(url)
            const res = await getUserAvatarByUserId.request()
            // console.log("res");
            const avatar = res.data.avatar
            setUserAvatar(avatar)
        }
    } catch (error) {
        // message.error('头部报错')
    }
}

// 创建一个延时的异步函数
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

// 调用 fetchData，并在调用之前添加延时
const callFetchDataWithDelay = async () => {
    await delay(1000) // 延时 1000 毫秒（1 秒）
    await fetchData()
}

callFetchDataWithDelay() // 调用延迟后的 fetchData //成功

const store = useSystemStore()
const { getUserInfoMation, getUserAvatar, getInfoAccount } = storeToRefs(store)

const username = computed(() => getUserInfoMation.value.nickName)
const defaultAvatar = computed(() => getUserAvatar.value)
const totalInfo = computed(() => getInfoAccount.value)

const avatarSelect = (key) => {
    switch (key) {
        case 'loginOut':
            doLogout()
            break
        // case 'editPassword':
        case 'editUserInfo':
            goUserInfo()
            break
        default:
            break
    }
}
const doLogout = () => {
    dialog.warning({
        title: '提示',
        content: '您确定要退出登录吗',
        positiveText: '确定',
        negativeText: '取消',
        onPositiveClick: () => {
            Api.loginout.request().then((result) => {
                if (result.code === '200') {
                    message.success(result.msg || '退出登录成功!')
                    loginoutClear()
                    return
                }
                message.error(result.msg || '退出登录失败!')
            })
        },
        // onNegativeClick: () => {},
    })
}

const router = useRouter()

const goToHelp = () => {
    router.push({ path: 'helpCenter' })
}

const goToInfoDetail = () => {
    router.push({ path: 'info', query: { type: 'not' } })
}

const goUserInfo = () => {
    router.push({ path: 'userInfo' })
}
// 跳转到大屏
const goToLargeScreen = () => {
    // 进行权限检查
    const hasPermission = roleList.value.some((item) => item.includes('ROLE_SUPER_ADMIN'))
    if (hasPermission) {
        //跳转到对应路径
        // router.push({ path: 'largeScreen' })
    } else {
        //
        message.info('您当前为普通用户，该功能暂未开放。')
    }
}
</script>

<style lang="less" scoped>
.header {
    width: 100%;
    height: 48px;
    // background: #F6FAFD;
    background: #fff;
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    z-index: 99;
    .header-left-content {
        display: flex;
        align-items: center;
        height: 26px;
        color: #19272e;
        font-weight: 500;
        font-size: 16px;
        margin-left: 20px;
        .line {
            width: 1px;
            // height: 1em;
            height: 16px;
            background: #dcdfe6;
            // margin: 0 16px;
        }
        .txt {
            height: 22px;
            // font-family: PingFangSC, PingFang SC;
            // font-weight: 500;
            font-weight: 400;
            font-size: 14px;
            color: #19272E;
            line-height: 22px;
            text-align: left;
            // font-style: normal;
        }
    }
    .header-right-content {
        margin-right: 20px;
    }
}
</style>
